import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { LanguageService } from '../services/language.service';

/**
 * Holds bootstrap until the session's catalogue has been fetched — the same reason the Google Maps
 * loader holds it in `main.ts`.
 *
 * Components across the app take their labels from a signal seeded with `translate.instant(SCOPE)`
 * and kept current by `translate.stream(SCOPE)`. `instant()` answers with the key itself when the
 * catalogue has not landed, so a view constructed in that window renders a string where it expects
 * an object and crashes on the first nested group it reads (`'LISTS'.COLUMNS.USER`). Nothing is
 * left to race once the language is in memory before the first component is constructed.
 *
 * Which language that is belongs to `LanguageService`, the one owner of that choice.
 */
export function provideTranslations(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(() => inject(LanguageService).load())]);
}
